import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import '../styles/Auth.css';

const API = process.env.REACT_APP_API_URL || '/api';

export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async () => {
        setError('');
        if (!password || !confirm) { setError('Please fill in all fields.'); return; }
        if (password !== confirm) { setError('Passwords do not match.'); return; }
        if (password.length < 8) { setError('Password too short (minimum 8 characters).'); return; }

        setLoading(true);
        try {
            const res = await fetch(`${API}/auth/reset-password.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });
            const data = await res.json();
            if (data.success) {
                setSuccess('Password updated! You can now log in.');
                setTimeout(() => navigate('/connexion'), 2500);
            } else {
                setError(data.error || 'An error occurred.');
            }
        } catch {
            setError('Unable to reach the server. Please check your connection.');
        }
        setLoading(false);
    };


    if (!token) {
        return (
            <div className="app-wrap">
                <Navbar />
                <div className="auth-wrap">
                    <div className="auth-card">
                        <div className="auth-title">ONLINEICO</div>
                        <div className="auth-error">Invalid or missing reset link.</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="app-wrap">
            <Navbar />
            <div className="auth-wrap">
                <div className="auth-card">
                    <div className="auth-title">ONLINEICO</div>
                    <div className="auth-subtitle">Set a new password</div>

                    {error && <div className="auth-error">{error}</div>}
                    {success && <div className="auth-success">{success}</div>}

                    {!success && (
                        <>
                            <div className="form-group">
                                <label className="form-label">New password</label>
                                <div style={{ position: 'relative' }}>
                                    <input className="form-input" type={showPassword ? 'text' : 'password'} placeholder="Minimum 8 characters" value={password} onChange={e => setPassword(e.target.value)} style={{ paddingRight: '40px' }} />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: '1.1rem', padding: 0 }}>
                                        {showPassword ? '◉' : '○'}
                                    </button>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="form-label">Confirm password</label>
                                <div style={{ position: 'relative' }}>
                                    <input className="form-input" type={showConfirm ? 'text' : 'password'} placeholder="••••••••" value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} style={{ paddingRight: '40px' }} />
                                    <button type="button" onClick={() => setShowConfirm(!showConfirm)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: '1.1rem', padding: 0 }}>
                                        {showConfirm ? '◉' : '○'}
                                    </button>
                                </div>
                            </div>
                            <button className="auth-btn" onClick={handleSubmit} disabled={loading}>
                                {loading ? 'Updating...' : 'Update my password'}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
